import "../../styles/background.css";
import Navbar from "../Navbar";

export default function Layout({ children }) {
  return (
    <div className="tech-bg min-h-screen text-white">
      <Navbar />
      <main className="pt-16">
        {children}
      </main>
    </div>
  );
}
